import styled from 'styled-components';

export default styled.div`
  && {
    .termination-of-lease {
      padding: 14px 40px;
      display: flex;
      justify-content: flex-end;
      .btn-termination-of-lease {
        width: 177px;
        height: 35px;
        border-radius: 5px;
        border: 1px solid #c4c4c4;
        box-sizing: border-box;
        color: #c4c4c4;
        background-color: #ffffff;
      }
    }
    .section {
      padding: 40px 65px;
      .delete-lease {
        box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        .info-delete-lease {
          padding: 40px 25px;
        }
      }
      .bd {
        border-bottom: 1px solid #dddddd;
      }
      .pb-16 {
        padding-bottom: 16px;
      }
      .pt-16 {
        padding-top: 16px;
      }
      .pl-5 {
        padding-left: 5px;
      }
    }
  }
`;
